module.exports = __webpack_public_path__ + "static/media/innovation-mob-footer.4b10e7fa.svg";